<template>
    <div>
        <div class="row my-4" v-for="evt in competitions">
            <div class="col-sm-12 col-md-4 image">
                <img class="img-fluid rounded py-1" :src="evt.image ? evt.image : '/frontend/images/competition_default.jpg'" :alt="evt.name">
            </div>
            <div class="col-sm-12 col-md-6 data pl-md-3">
                <div class="row evt-title">
                    <div class="col-12 px-md-0">
                        <h5><strong>{{ evt.is_challenge ? $t('Väljakutse') + ': ' : '' }}{{ evt.name }}</strong></h5>
                    </div>
                </div>
                <div class="row evt-data my-2">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-6">
                                <span>
                                    <i class="fa fa-calendar"></i>
                                    <span v-if="evt._period">
                                        {{ evt._period }}
                                    </span>
                                    <span v-else>-</span>
                                </span>
                            </div>
                            <div class="col-6">
                                <span>
                                    <i class="fa fa-map-marker"></i>
                                    <span v-if="evt.city">{{ evt.city }}</span>
                                    <span v-else>-</span>
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <span>
                                    <i class="fa fa-road"></i>
                                    <span v-if="evt.distancesList">{{ evt.distancesList.join(' / ') }}</span>
                                     <span v-else>-</span>
                                </span>
                            </div>
                            <div class="col-6">
                                <span>
                                    <i class="fa fa-user"></i>
                                    <span v-if="evt.participant_limit > 0">{{ evt.registrationsCount }} / {{ evt.participant_limit }}</span>
                                    <span v-else>-</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Packages -->
                <div class="row evt-choices my-1" v-if="evt.$packages.length > 0">
                    <div class="col-12">
                        <div class="row" v-for="pkg in evt.$packages">
                            <div class="col-9">
                                <div class="form-check">
                                    <div class="custom-control custom-radio">
                                        <input class="custom-control-input"
                                               type="radio"
                                               v-model="evt.$selected"
                                               :id="'reg-pkg-' + evt.id + '_' + pkg.id"
                                               :name="evt.id"
                                               :key="evt.id + '_' + pkg.id"
                                               :disabled="isPackageDisabled(evt, pkg)"
                                               :value="pkg">
                                        <label class="custom-control-label" :for="'reg-pkg-' + evt.id + '_' + pkg.id">
                                            {{ pkg.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 text-right">
                                <label class="form-check-label" :for="'reg-pkg-' + evt.id + '_' + pkg.id">
                                    {{ pkg.price }} €
                                </label>
                            </div>
                        </div>
                        <div class="row" v-if="evt.$selected !== null">
                            <div class="col-9">
                                <div class="form-check">
                                    <div class="custom-control custom-radio my-1">
                                        <input class="custom-control-input"
                                               type="radio"
                                               v-model="evt.$selected"
                                               :id="'reg-type-unselect-' + evt.id"
                                               :name="evt.id"
                                               :key="evt.id + 'none'"
                                               :value="null">
                                        <label class="custom-control-label" :for="'reg-type-unselect-' + evt.id">
                                            {{ $t('Ei osale') }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 text-right"></div>
                        </div>
                    </div>
                </div>

                <!-- ... no packages -->
                <div class="row evt-choices my-4" v-if="evt.$packages.length === 0">
                    <div class="col-12 text-right">
                        <p class="text-danger"><strong>{{ $t('Registreerimine pole hetkel avatud') }}</strong></p>
                    </div>
                </div>
                <!-- // Packages -->
            </div>
        </div>

        <div class="row action-btn-row my-4">
            <div class="col-4"></div>
            <div class="col-6">
                <button class="btn btn-success action-btn" :disabled="getSelected().length === 0" v-on:click="submitSelection()">
                    {{ $t('Vali võistlused') }}
                </button>
                <p v-for="successMessage in notifications.successes" class="text-success my-2">
                    {{ successMessage }}
                </p>
                <p v-for="errorMessage in notifications.errors" class="text-danger my-2">
                    {{ errorMessage }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import MrtNotifications from '../mrt-notifications';

export default {
    data() {
        return {
            notifications: new MrtNotifications(),
            competitions: []
        };
    },
    mounted() {
        axios.get(Mrt.config.routes['account.eventRegister.step1-competitions'])
            .then(
                (response) => {
                    this.competitions = response.data.events;
                }
            );
    },
    methods: {
        getSelected() {
            return this.competitions.filter((evt) => { return evt.$selected && evt.$selected.id; });
        },
        isPackageDisabled(evt, pkg) {
            let condition = true;

            if (pkg.medal && evt.participant_limit > 0) {
                condition = evt.$registeredWithMedalCount >= evt.participant_limit;
            }

            if (pkg.max_participants > 1) {
                condition = condition && this.isSingleRegSelected(evt);
            } else {
                condition = condition && this.isMultiRegSelected(evt);
            }

            return condition;
        },
        isSingleRegSelected(evtSelected) {
            return this.competitions.filter((evt) => { return evt.$selected && evt.$selected.max_participants === 1 && evt.id !== evtSelected.id; }).length > 0;
        },
        isMultiRegSelected(evtSelected) {
            return this.competitions.filter((evt) => { return evt.$selected && evt.$selected.max_participants > 1 && evt.id !== evtSelected.id; }).length > 0;
        },
        submitSelection() {
            if (this.getSelected().length === 0) {
                this.notifications.error(this.$t('Palun vali mõni üritus!'));
                return;
            }

            axios.post(Mrt.config.routes['account.eventRegister.step1-save'], {selected: this.getSelected()})
                .then((response) => {
                          if (response.data.status === 'success') {
                              this.notifications.success(this.$t('Salvestatud. Teid suunatakse osavõtjate lisamisse...'));

                              window.location.href = Mrt.config.routes['account.eventRegister.step2-participants'];
                          } else {
                              this.notifications.error(this.$t('Midagi läks valesti'));
                          }
                      }
                )
                .catch((err) => {
                    console.log(err);
                    this.notifications.error(this.$t('Midagi läks valesti'));
                });
        }
    }
};
</script>

<style scoped>

</style>
